import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles/variables';
import { Button, ButtonType } from '../atoms/button';
import { Overlay } from './overlay';
import { FirstStreakCompletionView } from '../molecules/first_streak_completion_view';
import { StreakConsecutiveDaysView } from '../molecules/streak_consecutive_days_view';
import { buildStreakCountdownText, STREAK_BUTTON_LABEL_CONTINUE, STREAK_BUTTON_LABEL_TOMORROW } from '../../messages';
// buttonContainer の CSS アニメーション完了までの時間（animationDelay 2.2s + animationDuration 0.5s）
const INITIAL_ANIMATION_DELAY_MS = 2700;
export const StreakRecordOverlay = ({ streakCompletionResult, countdownSeconds, onClose }) => {
    const isFirstDailyCompletion = streakCompletionResult === null || streakCompletionResult === void 0 ? void 0 : streakCompletionResult.isFirstDailyCompletion;
    const isFirstStreakCompletion = streakCompletionResult === null || streakCompletionResult === void 0 ? void 0 : streakCompletionResult.isFirstStreakCompletion;
    const [isFirstCompletionShown, setIsFirstCompletionShown] = React.useState(false);
    const [remainingSeconds, setRemainingSeconds] = React.useState(null);
    const resolvedIncrementAnimationUrl = streakCompletionResult === null || streakCompletionResult === void 0 ? void 0 : streakCompletionResult.resolvedIncrementAnimationUrl;
    const incrementMessage = streakCompletionResult === null || streakCompletionResult === void 0 ? void 0 : streakCompletionResult.incrementMessage;
    const shouldShowFirstCompletion = Boolean(isFirstStreakCompletion && isFirstCompletionShown);
    const shouldShowCountdown = Boolean(countdownSeconds);
    const buttonLabel = shouldShowFirstCompletion ? STREAK_BUTTON_LABEL_CONTINUE : STREAK_BUTTON_LABEL_TOMORROW;
    const handleClickButton = () => {
        if (isFirstStreakCompletion && !isFirstCompletionShown) {
            setIsFirstCompletionShown(true);
            return;
        }
        onClose();
    };
    React.useEffect(() => {
        if (!shouldShowCountdown || !streakCompletionResult) {
            setRemainingSeconds(null);
            return;
        }
        const isInitialScreen = !isFirstCompletionShown;
        const animationDelay = isInitialScreen ? INITIAL_ANIMATION_DELAY_MS : 0;
        setRemainingSeconds(null);
        let intervalId;
        let countdownTimeoutId;
        const delayTimerId = setTimeout(() => {
            setRemainingSeconds(countdownSeconds);
            intervalId = setInterval(() => {
                setRemainingSeconds((prev) => {
                    if (prev === null) {
                        return prev;
                    }
                    if (prev <= 1) {
                        clearInterval(intervalId);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            countdownTimeoutId = setTimeout(handleClickButton, countdownSeconds * 1000);
        }, animationDelay);
        return () => {
            clearTimeout(delayTimerId);
            if (intervalId)
                clearInterval(intervalId);
            if (countdownTimeoutId)
                clearTimeout(countdownTimeoutId);
        };
    }, [countdownSeconds, streakCompletionResult, shouldShowCountdown, isFirstCompletionShown]);
    if (!isFirstDailyCompletion) {
        return null;
    }
    return (React.createElement(Overlay, { background: Colors.OrangeLight, extendBackgroundToBrowserEdges: true },
        React.createElement("div", { className: css(styles.contents) },
            React.createElement("div", { className: css(styles.spacer) }),
            shouldShowFirstCompletion ? (React.createElement(FirstStreakCompletionView, { streakCount: streakCompletionResult.currentStreak })) : (React.createElement(StreakConsecutiveDaysView, { streakCompletionResult: streakCompletionResult, animationUrl: resolvedIncrementAnimationUrl, message: incrementMessage })),
            React.createElement("div", { className: css(styles.buttonContainer) },
                React.createElement(Button, { buttonType: ButtonType.primary, className: css(styles.closeButton), isRadius: true, fullWidth: true, onClick: handleClickButton }, buttonLabel),
                shouldShowCountdown && (React.createElement("div", { className: css(styles.countdownContainer, remainingSeconds === null && styles.countdownHidden) },
                    React.createElement("span", { className: css(styles.countdownText) }, buildStreakCountdownText(remainingSeconds !== null && remainingSeconds !== void 0 ? remainingSeconds : countdownSeconds))))))));
};
const fadeIn = {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
};
const styles = StyleSheet.create({
    contents: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
        maxWidth: 345,
    },
    spacer: {
        flex: 1,
    },
    buttonContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: 12,
        margin: '14px 0',
        animationName: [fadeIn],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-out',
        animationDelay: '2.2s',
        animationFillMode: 'both',
    },
    countdownContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    countdownHidden: {
        visibility: 'hidden',
    },
    countdownText: {
        fontSize: 12,
        lineHeight: 1,
        fontWeight: 500,
        letterSpacing: 0.48,
    },
    closeButton: {
        fontSize: 16,
        letterSpacing: 1.28,
        fontWeight: 'bold',
        border: 'unset',
        background: Colors.Orange,
    },
});
